// Axios
import Axios from "./axios"

export const getCategories = () => {
    return new Promise((resolve, reject) => {
        const data = Axios.get(`/news/getCategories`)
        setTimeout(() => resolve(data), 0)
    })

}